/*
 * @Author: hzm
 * @Date: 2024-04-03 10:30:54
 * @Description: 
 */
import "../assets/hina/hina.esm.min.js"

const hina = window['hinaDataStatistic'];
// 用配置对象初始化 SDK
hina.init({
  // 配置采集上报地址URL
  serverUrl: import.meta.env.VITE_APP_HAINA, // 配置采集上报地址URL（在线申请），查看如下【[采集上报地址获取] 链接
  showLog: true,
  // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 H_pageview 事件
  isSinglePage: true,
  autoTrackConfig: {
    // 是否开启自动点击采集, true表示开启，自动采集 H_WebClick 事件
    clickAutoTrack: true,
    // 是否开启页面停留采集, true表示开启，自动采集 H_WebStay 事件
    stayAutoTrack: true,
  },
});
hina.quick('autoTrack');
// 将 SDK 实例赋给全局变量 hina，或者其他您指定的变量
window['hina'] = hina;
